import axios from "axios";

const BASE_API_URL = "/api/library";

//使用者端「雲閣藏書」API：只看 published 的文章
//  全站慣例：POST + body，即使是唯讀端點也用 POST 統一
class LibraryService {
  //L-1 文章列表 body: { keyword, category, sort: "new" | "hot", skip, limit }
  getArticles(body = {}) {
    return axios.post(BASE_API_URL + "/articles", body);
  }

  //L-2 藏書首頁推薦文章 body: { limit }
  getRecommended(body = {}) {
    return axios.post(BASE_API_URL + "/articles/recommended", body);
  }

  //L-3 藏書首頁看板（工具書 / 推薦 / 最新 / categories 一次撈）
  getBoard() {
    return axios.post(BASE_API_URL + "/board");
  }

  //L-4 單篇文章詳情（含 content）；草稿 / 不存在都會 404
  //  例外走 GET + path param：公開內容，未來 CDN 可以快取
  getArticle(articleID) {
    return axios.get(BASE_API_URL + "/articles/" + articleID);
  }

  //—— 互動 API ——

  //L-5 Toggle 按讚（需要 userValidCode === "2"）
  //  401 needsLogin：請先登入；403 needsRegister：請完成註冊
  //  成功回 { active, count }：active 表示動作後狀態（按了 / 取消）
  toggleLike(articleID) {
    return axios.post(BASE_API_URL + "/articles/like", { articleID });
  }

  //L-6 Toggle 收藏（同樣要求 validCode === "2"）
  toggleCollect(articleID) {
    return axios.post(BASE_API_URL + "/articles/collect", { articleID });
  }

  //L-7 分享計數 +1（任何人都能按）
  share(articleID) {
    return axios.post(BASE_API_URL + "/articles/share", { articleID });
  }

  //L-8 查我對哪些文章按過讚 / 收藏
  //  articleIDs 陣列：只查這些；空陣列 = 撈全部（我的收藏頁用）
  //  未登入會回空陣列、不報錯，可放心呼叫
  getMyActions(articleIDs = []) {
    return axios.post(BASE_API_URL + "/me/actions", { articleIDs });
  }

  //L-9 我的收藏列表（要求登入 + validCode==="2"）
  //  body: { category, skip, limit }
  getMyCollected(body = {}) {
    return axios.post(BASE_API_URL + "/me/collected", body);
  }

  //L-10 類別列表（給側欄選單動態顯示用）
  getCategories() {
    return axios.post(BASE_API_URL + "/categories");
  }
}

export default new LibraryService();
